export enum CustomizationTabs {
    Display = "display",
    Styles = "styles"
}
